import { useSession } from '@hooks/useSession';

import { getReferenceRangeMap } from '@utils/reference_range';

import {
  useGetReferenceRanges as _useGetReferenceRanges,
  type GetReferenceRangesQueryVariables,
} from 'generated/reference_range.generated';
import type {
  ReferenceRangeRiskLevel,
  ReferenceRangeRiskModel,
} from 'generated/types';

export const useGetReferenceRanges = (
  params: Omit<
    GetReferenceRangesQueryVariables['input'],
    'parameter_type' | 'vitall_patient_id'
  >
) => {
  const {
    state: { activeProfile },
  } = useSession();
  const vitall_patient_id = activeProfile?.vitall_patient_id ?? '';
  const response = _useGetReferenceRanges({
    variables: {
      input: {
        ...params,
        vitall_patient_id,
      },
    },
    skip: !vitall_patient_id,
  });
  const data = response.data?.getReferenceRanges ?? [];
  return {
    ...response,
    data,
  };
};

export function useParameterReferenceRange(code: string, category?: string) {
  const response = useGetReferenceRanges({
    codes: [code],
    category,
  });
  const [refRanges] = response.data;

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const data: Map<ReferenceRangeRiskLevel, ReferenceRangeRiskModel> = refRanges
    ? getReferenceRangeMap(refRanges)
    : new Map();
  return { ...response, data };
}
